import { Icon } from '/@/components/Icon';
import { resultSuccess, resultError, getRequestToken, requestParams } from '../_util';
import { MockMethod } from 'vite-plugin-mock';
import { createFakeUserList } from './user';

// 头部菜单------------------（一级菜单）
const topMenus = [
  {
    // 路由地址
    path: 'https://test-saas.ciic-cloud.cn',
    // 路由唯一name
    name: 'dashboard',
    // 组件
    component: 'IFRAME',
    // 重定向
    // redirect: '/dashboard/workbench',
    // 路由配置
    meta: {
      // 菜单位置排序
      orderNo: 1,
      // 菜单图标
      // icon: 'ion:grid-outline',
      // icon:'icon-shouye',
      // 菜单名称
      title: 'routes.dashboard.workbench',
      // 改路由属于xxx（work）头部菜单模块
      routerType: 'work',
      // 是否头部菜单（true为头部菜单，false不是头部菜单）（当showInTopMenu为false时可以不返这个字段，头部菜单都为true，左侧菜单都为false）
      showInTopMenu: true,
      // 是否展示左侧菜单（true为不展示，false为展示）
      hiddenSlideBar: true,
    },
  },
  {
    path: 'https://test-saas.ciic-cloud.cn/shebao',
    name: 'socialSecurityHead',
    component: 'IFRAME',
    meta: {
      // icon: 'ion:layers-outline',
      title: 'routes.socialSecurity.socialSecurity',
      orderNo: 10,
      routerType: 'shebao',
      showInTopMenu: true,
      hiddenSlideBar: false,
    },
  },
  {
    // path: 'http://local-qian.ciic-cloud.cn/qiye',
    path: 'https://test-saas.ciic-cloud.cn/qiye',
    name: 'companyCenter',
    component: 'IFRAME',
    // redirect: '/company/center/infomation',
    meta: {
      orderNo: 15,
      // icon: 'icon-qiyezhongxin',
      routerType: 'company',
      title: 'routes.company.company',
      showInTopMenu: true,
      // hiddenSlideBar: false,
    },
  },
]

const topMenus2 = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: 'LAYOUT',
    redirect: '/dashboard/workbench',
    meta: {
      orderNo: 1,
      // icon: 'ion:grid-outline',
      // icon:'icon-shouye',
      title: 'routes.dashboard.workbench',
      routerType: 'work',
      showInTopMenu: true,
      hiddenSlideBar: true,
    },
  },
  {
    path: '/socialSecurityHead',
    name: 'socialSecurityHead',
    component: 'LAYOUT',
    redirect: '/socialSecurity/archives',
    meta: {
      // icon: 'ion:layers-outline',
      title: 'routes.socialSecurity.socialSecurity',
      orderNo: 10,
      routerType: 'shebao',
      showInTopMenu: true,
      hiddenSlideBar: false,
    },
  }
]


// 休假管理
const holiday = {
  // 路由地址
  path: '/holiday',
  // 路由唯一name
  name: 'Holiday',
  // 组件
  component: 'LAYOUT',
  // 重定向
  redirect: '/holiday/leaveApplication',
  // 路由配置
  meta: {
    // 菜单位置排序
    orderNo: 11,
    // 菜单图标
    // icon: 'ion:layers-outline',
    icon:'icon-xiujiaguanli',
    // 菜单名称
    title: 'routes.holiday.holiday',
    // 改路由属于xxx（shebao）头部菜单模块
    // routerType: 'information',
    // 是否头部菜单（true为头部菜单，false不是头部菜单）（当showInTopMenu为false时可以不返这个字段，头部菜单都为true，左侧菜单都为false）
    showInTopMenu: false,
    // 是否展示左侧菜单（true为不展示，false为展示）
    hiddenSlideBar:false,
  },
  // 三级菜单
  children: [
    // 休假申请
    {
      path: 'leaveApplication',
      name: 'LeaveApplication',
      component: '/holiday/leaveApplication/index.vue',
      meta: {
        icon:'icon-xiujiashenqing',
        title: 'routes.holiday.leaveApplication',
        // routerType: 'shebao',
        orderNo: 1
      },
    },
    // 休假审批
    {
      path: 'leaveApproval',
      name: 'LeaveApproval',
      component:'/holiday/leaveApproval/index.vue',
      meta: {
        icon:'icon-xiujiashenpi',
        // routerType: 'shebao',
        title: 'routes.holiday.leaveApproval',
        orderNo: 2
      },
    }
  ]
}
// 通讯录
const communication = {
  path: '/communication',
  name: 'Communication',
  component: 'LAYOUT',
  redirect: '/communication/communicationList',
  meta: {
    orderNo: 20,
    icon:'icon-canbaodangan',
    title: 'routes.holiday.communication',
    hideChildrenInMenu: true,
  },
  children: [
    // 通讯录列表
    {
      path: 'communicationList',
      name: 'LommunicationList',
      component: '/communication/communicationList/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.holiday.communication',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

// 智享签(合同管理)
const contractSign = {
  path: '/contractSign',
  name: 'ContractSign',
  component: 'LAYOUT',
  redirect: '/contractSign/filemanage',
  check: true,
  meta: {
    orderNo: 10,
    icon:'icon-canbaodangan',
    title: 'routes.sign.contractSign',
    hideChildrenInMenu: false,
  },
  children: [
    {
      check: true,
      path: 'filemanageList',
      name: 'FilemanageList',
      component: '/contractSign/filemanage/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.sign.filemanage',
      }
    },
    {
      check: true,
      path: 'certificate',
      name: 'CertificateList',
      component: '/contractSign/certificate/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.sign.certificate',
      }
    },
    {
      check: true,
      path: 'https://www.ciic-cloud.cn/serviceTool/fileVerification',
      name: 'FileCheckSign',
      component: 'IFRAME',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.sign.fileCheckSign',
      },
    }
  ]
}

// 休假管理
const vacation = {
  path: '/vacation',
  name: 'Vacation',
  component: 'LAYOUT',
  redirect: '/vacation/applyLeave',
  meta: {
    orderNo: 30,
    icon:'icon-canbaodangan',
    title: 'routes.vacation.vacation',
    hideChildrenInMenu: false,
  },
  children: [
    {
      path: 'applyLeave',
      name: 'ApplyLeave',
      component: '/vacation/applyLeave/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.vacation.applyLeave',
      }
    },
    {
      path: 'applyTodo',
      name: 'ApplyTodo',
      component: '/vacation/applyTodo/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.vacation.applyTodo',
      }
    }
  ]
}

// 公告管理
const announcement = {
  path: '/announcement',
  name: 'Announcement',
  component: 'LAYOUT',
  redirect: '/announcement/announcementList',
  meta: {
    orderNo: 30,
    icon:'icon-canbaodangan',
    title: 'routes.holiday.announcement',
    hideChildrenInMenu: true,
  },
  children: [
    // 公告管理列表
    {
      path: 'announcementList',
      name: 'AnnouncementList',
      component: '/announcement/announcementList/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.holiday.announcement',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

// 月报信息
const monthlyReport = {
  path: '/monthlyReport',
  name: 'MonthlyReport',
  component: 'LAYOUT',
  redirect: '/monthlyReport/monthlyReportList',
  meta: {
    orderNo: 40,
    icon:'icon-canbaodangan',
    title: 'routes.holiday.monthlyReport',
    hideChildrenInMenu: true,
  },
  children: [
    // 月报信息列表
    {
      path: 'monthlyReportList',
      name: 'MonthlyReportList',
      component: '/monthlyReport/monthlyReportList/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.holiday.monthlyReport',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

// 系统设定
const systemSettings = {
  path: '/systemSettings',
  name: 'SystemSettings',
  component: 'LAYOUT',
  redirect: '/systemSettings/systemSettingsList',
  meta: {
    orderNo: 50,
    icon:'icon-canbaodangan',
    title: 'routes.holiday.systemSettings',
    hideChildrenInMenu: true,
  },
  children: [
    // 系统设定列表
    {
      path: 'systemSettingsList',
      name: 'SystemSettingsList',
      component: '/systemSettings/systemSettingsList/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.holiday.systemSettings',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

// 信息填报
const information = {
  path: '/information',
  name: 'Information',
  component: 'LAYOUT',
  redirect: '/information/informationList',
  meta: {
    orderNo: 9,
    icon:'icon-canbaodangan',
    title: 'routes.holiday.information',
    hideChildrenInMenu: true,
  },
  children: [
    // 信息填报列表
    {
      path: 'informationList',
      name: 'InformationList',
      component: '/information/informationList/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.holiday.information',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

// 工作台
const workbenches = {
  path: '/workbenches',
  name: 'Workbenches',
  component: 'LAYOUT',
  redirect: '/workbenches/index',
  meta: {
    orderNo: 10,
    icon:'icon-canbaodangan',
    title: 'routes.examinationStudent.workbenches',
    hideChildrenInMenu: true,
  },
  children: [
    // 首页详情
    {
      path: 'index',
      name: 'WorkbenchesIndex',
      component: '/workbenches/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.workbenches',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

// 客户管理
const customerManagement = {
  path: '/customerManagement',
  name: 'CustomerManagement',
  component: 'LAYOUT',
  redirect: '/customerManagement/index',
  meta: {
    orderNo: 20,
    icon:'icon-canbaodangan',
    title: 'routes.examinationStudent.customerManagement',
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'customerManagementIndex',
      component: '/customerManagement/index.vue',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.customerManagement',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}

//项目管理
const projectManagement = {
  path: '/projectManagement',
  name: 'ProjectManagement',
  component: 'LAYOUT',
  redirect: '/projectManagement/index',
  meta: {
    orderNo: 30,
    icon:'icon-canbaodangan',
    title: 'routes.examinationStudent.projectManagement',
    hideChildrenInMenu: false,
  },
  children: [
    {
      path: 'index',
      name: 'projectManagementIndex',
      component: '/projectManagement/proManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.projectManagement',
      }
    },
    {
      path: 'postManagement',
      name: 'PostManagement',
      component: '/projectManagement/postManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.postManagement',
      }
    }
  ]
}
// 招考管理
const recruitmentManagement = {
  path: '/recruitmentManagement',
  name: 'RecruitmentManagement',
  component: 'LAYOUT',
  redirect: '/recruitmentManagement/index',
  meta: {
    orderNo: 40,
    icon:'icon-canbaodangan',
    title: 'routes.examinationStudent.recruitmentManagement',
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'RecruitmentManagementIndex',
      component: '/recruitmentManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.recruitmentManagement',
        // routerType: 'shebao',
        orderNo: 1
      }
    }
  ]
}
//系统管理
const systemManagement = {
  path: '/systemManagement',
  name: 'SystemManagement',
  component: 'LAYOUT',
  redirect: '/dictionaryManagement/index',
  meta: {
    orderNo: 50,
    icon:'icon-canbaodangan',
    title: 'routes.examinationStudent.dictionaryManagement',
    hideChildrenInMenu: false,
  },
  children: [
    {
      path: '/dictionaryManagement/index',
      name: 'dictionaryManagement',
      component: '/systemManagement/dictionaryManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.dictionaryManagement',
      }
    },
    {
      path: 'formManagement/index',
      name: 'formManagement',
      component: '/systemManagement/formManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.formManagement',
      }
    },
    {
      path: 'rolesManagement/index',
      name: 'RolesManagement',
      component: '/systemManagement/rolesManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.rolesManagement',
      }
    },
    {
      path: 'userManagement/index',
      name: 'UserManagement',
      component: '/systemManagement/userManagement/index',
      meta: {
        icon:'icon-canbaorenguanli',
        title: 'routes.examinationStudent.userManagement',
      }
    }
  ]
}




const menuRoute = ['dashboard','Dashboard','Workbench','socialSecurity','Archives','Increase','Reduction','Supplementary','InsuredSetting','SocialArchives']
const menuRoute2 = ['dashboard','Dashboard','Workbench','socialSecurity','Archives','Increase','Reduction','Supplementary']

export default [
  {
    url: '/basic-api/getMenuList',
    timeout: 1000,
    method: 'get',
    response: (request: requestParams) => {
      const token = getRequestToken(request);
      if (!token) {
        return resultError('Invalid token!');
      }
      const checkUser = createFakeUserList().find((item) => item.token === token);
      if (!checkUser) {
        return resultError('Invalid user token!');
      }
      const id = checkUser.userId;
      let menu: Object;
      switch (id) {
        case '102674':
          // dashboardRoute.redirect = dashboardRoute.path + '/' + dashboardRoute.children[0].path;
          menu = {
            // topMenus:topMenus2,
            topMenus:topMenus,
            leftMenus:[workbenches,customerManagement,projectManagement,recruitmentManagement,systemManagement]
          }
          // menu = menuRoute;
          break;
        case '3bf81c97820d4c5284e770aed3d8e6a7':
          // dashboardRoute.redirect = dashboardRoute.path + '/' + dashboardRoute.children[1].path;
          menu = {
            topMenus:topMenus2,
            leftMenus:[holiday]
          }
          break;
        default:
          menu = [];
      }

      return resultSuccess(menu);
    },
  },
] as MockMethod[];
